import { render } from "./BankDetailView.vue?vue&type=template&id=530c4202&scoped=true&ts=true"
import script from "./BankDetailView.vue?vue&type=script&lang=ts"
export * from "./BankDetailView.vue?vue&type=script&lang=ts"

import "./BankDetailView.vue?vue&type=style&index=0&id=530c4202&scoped=true&lang=css"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530c4202"]])

export default __exports__